import { useIntl } from 'react-intl';
import styles from './NoResults.module.scss';

const NoResults = () => {
    const intl = useIntl();
    return (
        <div className={styles.container} data-testid="mapPage.search.noResult">
            {intl.formatMessage({ id: 'search.noResults' })}
        </div>
    );
};

export default NoResults;
